import { css, type Theme } from "@emotion/react";

export const summaryContainer = (theme: Theme) => css`
  & {
    border: 0;
    border-top: 4px solid ${theme.accent.sand.backgroundMuted1};
  }
`;

export const centerText = css`
  text-align: center;
`;

export const interpretationSection = (theme: Theme) => css`
  border-top: 1px solid ${theme.system.borderBase};
  padding-top: 1rem;
`;

export const orderItem = css`
  margin-bottom: 0.25rem;
  margin-left: 0.5rem;
`;

export const itemIcon = (theme: Theme) => css`
  color: ${theme.system.textBase};
  width: 1rem;
`;

export const subtotalSection = css`
  display: flex;
  justify-content: space-between;
`;
